const StatsStockageIntegrated = ({language , token}) => {
    const newStatsStockageIframe = "https:" +
    window.process.env.URL_StatsStockage
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_statsStockage_display"
        src={newStatsStockageIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsStockageIntegrated